/* eslint-disable arrow-body-style */
import type { FC, Ref } from "react";
import { Avatar, type AvatarProps } from "@huub-web/ui";

type AdvisorAvatarProps = Omit<AvatarProps, "image" | "value"> & {
  badge?: boolean;
  ref?: Ref<HTMLDivElement>;
};

/**
 * Avatar component for displaying advisor with online status badge
 */
export const AdvisorAvatar: FC<AdvisorAvatarProps> = ({
  size = "l",
  ref,
  ...props
}) => {
  // TODO: make dynamic

  return (
    <Avatar
      ref={ref}
      value="Adviseur"
      image="/assets/images/adviseur.jpg"
      size={size}
      {...props}
    >
      {/* {badge && (
        <Badge
          offset="small"
          value={<Icon icon="circleFilled" size="xxs" />}
          variant="success"
          size="xxs"
        />
      )} */}
    </Avatar>
  );
};
